//--------------------| Objeto vacio  |--------------------
export let usuarioVacio = {
    // id: null,
    // nombre: "",
    // apellidoPaterno: "",
    // apellidoMaterno: "",
    // idRol: "",
    // // idPlanta: "",
    // idEstatus: 1


    id: null,
    nombre: "",
    apellidos: "",
    idRol: "",
    // plantas: [],
    email: "",
    usuario: "",
    idEstatus: 1
}